export default {
	/**
	 * Resolves an array of unassigned device objects for the given client.
	 *
	 * @param {int} clientId
	 * @param {int} page The page number to load
	 * @returns {Promise<array>}
	 */
	async getUnassigned (clientId, page) {},

	/**
	 * Resolves an array of device objects for the given client and group, filtered by the given device type ID.
	 *
	 * @param {int} clientId
	 * @param {int} groupId
	 * @param {int} deviceTypeId
	 * @returns {Promise<array>}
	 */
	async getFromGroupWithDeviceType (clientId, groupId, deviceTypeId) {},

	/**
	 * Assigns the given array of device IDs to the given group.
	 *
	 * @param {array} deviceIds An array of device IDs
	 * @param {int} clientId The client ID
	 * @param {int} id The group ID to assign to
	 * @returns {Promise}
	 */
	async assign (deviceIds, clientId, id) {},

	/**
	 * Unassigns the given array of device IDs from their assigned group.
	 *
	 * @param {array} deviceIds An array of device IDs
	 * @param {int} clientId The client ID
	 * @param {int} id The group ID to assign to
	 */
	async unassign (deviceIds, clientId, id) {},

	/**
	 * Retrieves a single device from the given client, group, and device ID.
	 *
	 * @param {int} clientId The client ID
	 * @param {int} groupId The group ID
	 * @param {int} id The device ID
	 * @returns {Promise<object>}
	 */
	async getDevice (clientId, groupId, id) {},

	/**
	 * Retrieves an array of monitors from the given client, group, and device ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 * @param {int} deviceId The device ID to query against
	 * @returns {Promise<array>}
	 */
	async getMonitors (clientId, groupId, deviceId) {},

	/**
	 * Retrieves an array of monitor types from the given device ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 * @param {int} deviceId The device ID to query against
	 */
	async getMonitorTypes (clientId, groupId, deviceId) {},

	/**
	 * Retrieves the given monitor type from the given device ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 * @param {int} deviceId The device ID to query against
	 * @param {string} monitorType The monitor type key
	 * @param {object} settings The settings to be sent with the query
	 */
	async getMonitorType (clientId, groupId, deviceId, monitorType, settings) {},

	/**
	 * Retrieves an array of inherited monitors from the given client, group, and device ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 * @param {int} deviceId The device ID to query against
	 * @returns {Promise<array>}
	 */
	async getInheritedMonitors (clientId, groupId, deviceId) {},

	/**
	 * retrieves the notifications for a device
	 *
	 * @param clientId
	 * @returns {Promise<Array|Object|string>}
	 */
	async getNotifications (deviceId) {}
};
